import { SplashView } from '../SplashController';
import { TranslationTexts } from '../../../config/translate/TranslationTexts';
import { FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { gsap } from 'gsap';
import { GameAssets } from '../../../GameAssets';
import { GameData } from '../../../server/data/GameData';
import { BitmapCountUp } from '../../../../core/component/BitmapCountUp';
import { Translator } from '../../../../core/setting/Translator';
import { Helper } from '../../../../core/utils/Helper';
import { BitmapTextStyleOptions, TextStyleOptions } from '../../../../core/setting/text/IText';
import { NolimitApplication } from '@nolimitcity/slot-launcher/bin/NolimitApplication';
import { Beheaded } from '../../../Beheaded';
import { BeheadedSound } from '../../../sound/BeheadedSound';
import { IDimOrientation, LayoutDimData, ResizeHelper } from '../../../../core/utils/ResizeHelper';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { SoundConfig } from '../../../config/sound/SoundConfig';

export interface OutroData {
    fsPlayed: number;
    totalAmount: number;
    level: number;
}

export class SplashViewFsOutro extends PIXI.Container implements SplashView {
    private totalWin: PIXI.Text;
    // private counter: BitmapCountUp;
    private _timeLine: gsap.core.Timeline;
    private freeSpinPlayedText: PIXI.Text;
    private isBelowWinStack: boolean;
    private DEFAULT_TXT_STYLE: TextStyleOptions;
    private pickOption1: PIXI.Sprite;
    private pickOption2: PIXI.Sprite;

    private badOutroSp: PIXI.Sprite;

    private possibleWinAmount: PIXI.Text;

    protected readonly counterDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360),
        },
        portrait: {
            scale: new PIXI.Point(0.65, 0.65),
            position: new PIXI.Point(360, 360),
        },
    };

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 32,
        letterSpacing: 12,
    };

    private static _presentationData: OutroData = {
        level: 2,
        totalAmount: 123456789,
        fsPlayed: 1,
    };

    private readonly styleTotal: TextStyleOptions = {
        fontFamily: 'Helvetica',
        fontSize: 68,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: ['#fffb00', '#c93'],
        stroke: '#600',
        strokeThickness: 4,
    };

    constructor(textStyle: TextStyleOptions) {
        super();

        this.DEFAULT_TXT_STYLE = textStyle;
        this.init();
        this.visible = false;
    }

    public setData(data: GameData): void {
        this.freeSpinPlayedText.text =
            Translator.translate(TranslationTexts.FREESPINS_PLAYED) + ' ' + data.raw.numberOfFreespinsPlayed.toString();
        this.totalWin.visible = !data.Win.isWinBelowStake() && data.Win.totalWin > 0;
        this.badOutroSp.visible = !data.Win.totalWin;
        this.isBelowWinStack = data.Win.isWinBelowStake();
    }

    public get dim(): LayoutDimData {
        return ResizeHelper.calcDim(this.counterDim);
    }

    private init(): void {
        this.pickOption1 = new PIXI.Sprite(Beheaded.assetLoader.getTextures('choose_a_potion/bigWin')[0]);
        this.pickOption1.anchor.set(0.5, 0.5);
        this.pickOption1.scale.set(0.5, 0.5);
        this.pickOption1.position.set(-230, 230);
        this.pickOption1.alpha = 0;
        this.pickOption2 = new PIXI.Sprite(Beheaded.assetLoader.getTextures('choose_a_potion/maxWin')[0]);
        this.pickOption2.anchor.set(0.5, 0.5);
        this.pickOption2.scale.set(0.5, 0.5);
        this.pickOption2.position.set(230, 230);
        this.pickOption2.alpha = 0;
        this.possibleWinAmount = new PIXI.Text('', {
            fontFamily: 'Helvetica',
            fontSize: 30,
            fontWeight: FontWeight.EXTRA_BOLD,
            fill: ['#fffb00', '#c93'],
            stroke: '#600',
            strokeThickness: 4,
        });
        this.possibleWinAmount.anchor.set(0.5, 0.5);
        this.possibleWinAmount.position.set(-230, 250);
        this.possibleWinAmount.alpha = 0;
        this.addChild(this.pickOption1, this.pickOption2, this.possibleWinAmount);

        // TEXT TOTAL
        this.totalWin = new PIXI.Text(Translator.translate(TranslationTexts.TOTAL_WIN));
        this.totalWin.style = this.styleTotal;
        this.totalWin.position = new PIXI.Point(0, -200);
        this.totalWin.anchor.set(0.5, 0.5);
        this.addChild(this.totalWin);
        this.totalWin.scale.set(1);

        Helper.ResizeText(this.totalWin, 600);

        this.freeSpinPlayedText = new PIXI.Text(Translator.translate(TranslationTexts.FREESPINS_PLAYED));
        this.freeSpinPlayedText.style = this.styleTotal;
        this.freeSpinPlayedText.position = new PIXI.Point(0, 100);
        this.freeSpinPlayedText.anchor.set(0.5, 0.5);
        this.addChild(this.freeSpinPlayedText);

        Helper.ResizeText(this.freeSpinPlayedText, 600);

        this.badOutroSp = this.addChild(new PIXI.Sprite(Beheaded.assetLoader.getTextures("badOutro")[0]))
        this.badOutroSp.anchor.set(0.5);
        this.badOutroSp.position.set(0,-130);
        
        // COUNTER
        // this.counter = this.addChild(new BitmapCountUp(this._style));
        // this.counter.alpha = 1;
        // this.counter.anchor = new PIXI.Point(0.5, 0.5);
        // this.counter.position.set(0, -120);
        // this.addChild(this.counter);
        // this.counter.showValue(SplashViewFsOutro._presentationData.totalAmount);
        // this.onResize();
    }

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onStart: () => {
                    this.visible = true;
                    if (GameSetting.isPortugal) {
                        let playerSelect = Beheaded.model.gameData.raw.playerSelect;
                        this.possibleWinAmount.position.x = this.pickOption2.position.x;
                        this.pickOption1.alpha = 1;
                        this.pickOption2.alpha = 0.5;
                        let text = Beheaded.model.gameData.raw.winAmountSecondChoice + 'X';
                        if (playerSelect === 2) {
                            this.possibleWinAmount.position.x = this.pickOption1.position.x;
                            text = Beheaded.model.gameData.raw.winAmountFirstChoice + 'X';
                            this.pickOption1.alpha = 0.5;
                            this.pickOption2.alpha = 1;
                        }
                        this.possibleWinAmount.text = text;
                        this.possibleWinAmount.alpha = 0.5;
                    }
                },
            })
        );

        if (!Beheaded.model.isWinBelowStakeAllNoRestriction) {
            Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_END_GOOD);
        } else {
            Beheaded.soundPlayer.playSound(SoundConfig.FS_OUTRO_END_BAD);
        }

        if (!this.isBelowWinStack) {
            this._timeLine.add(() => {
                // Beheaded.soundPlayer.playSound(BeheadedSound.COUNT_UP_ENDS[3]);
            });
        }
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.5, alpha: 1 }, 0);
        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(
            this._timeLine,
            new gsap.core.Timeline({
                onComplete: () => {
                    this.visible = false;
                    this.possibleWinAmount.alpha = 0;
                    this.pickOption2.alpha = 0;
                    this.pickOption1.alpha = 0;
                },
            })
        );
        Beheaded.counter.stop(undefined,0.35,0,true);
        this._timeLine.to(this, { duration: 0.35, alpha: 0 });

        return this._timeLine;
    }

    public onResize(): void {
        this.scale = this.dim.scale;
    }
}
